export interface ScreenResize {
  width: number;
  height: number;
}
